var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.7495 3.84961H2.24954C2.07275 3.84961 1.92811 3.99425 1.92811 4.17104V6.74247C1.92811 6.91925 2.07275 7.0639 2.24954 7.0639H33.7495C33.9263 7.0639 34.071 6.91925 34.071 6.74247V4.17104C34.071 3.99425 33.9263 3.84961 33.7495 3.84961ZM33.7495 28.921H2.24954C2.07275 28.921 1.92811 29.0657 1.92811 29.2425V31.8139C1.92811 31.9907 2.07275 32.1353 2.24954 32.1353H33.7495C33.9263 32.1353 34.071 31.9907 34.071 31.8139V29.2425C34.071 29.0657 33.9263 28.921 33.7495 28.921ZM33.7495 16.3853H2.24954C2.07275 16.3853 1.92811 16.53 1.92811 16.7068V19.2782C1.92811 19.455 2.07275 19.5996 2.24954 19.5996H33.7495C33.9263 19.5996 34.071 19.455 34.071 19.2782V16.7068C34.071 16.53 33.9263 16.3853 33.7495 16.3853Z",
    fill: "#8C8CA2",
    fillOpacity: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.9a695180a7406be1d4bfb87921f0f425.svg";
export { ForwardRef as ReactComponent };